import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { PartnerDetailProContentComponent } from '../partner-detail-pro-content/partner-detail-pro-content.component';

@Component({
  selector: 'app-pro-partner-details',
  templateUrl: './pro-partner-details.component.html',
  styleUrls: ['./pro-partner-details.component.scss']
})
export class ProPartnerDetailsComponent implements OnInit {
  //passed in id in order to pull partner data
  partnerId: number;

  @ViewChild(PartnerDetailProContentComponent)
  partnerDetailsComponent!: PartnerDetailProContentComponent;

  constructor(private route: ActivatedRoute, private partnerService: PartnerService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.partnerId = Number(params['partnerId']);
      console.log('Partner ID:', this.partnerId);

      //pull partner data
      this.partnerService.getPartner(this.partnerId).subscribe((resPartner) => {
        //set global selected partner
        this.partnerService.setSelectedPartner(resPartner);
      });

      //pull all partner groups for member
      this.partnerService.getPartnerGroupsForPartner(this.partnerId).subscribe((resPartnerGroups) => {
        this.partnerService.setPartnerGroups(resPartnerGroups);
      });
    });
  }

  handleGetPros() {
    // this.hasClickedGetPros = true;
    this.partnerDetailsComponent.getPros();
  }

}
